import {
  CreateWebComponentTokenRequest,
  CreateWebComponentTokenResponse,
  GetMerchantConnectionRequest,
  GetMerchantConnectionResponse,
  GetSubAccountSettingsRequest,
  GetSubAccountSettingsResponse,
  ListDisputesRequest,
  ListDisputesResponse,
} from '@weave/schema-gen-ts/dist/schemas/payments-platform/justifi-integration/justifi_integration.pb';
import { CustomAxios } from 'redux/axios';

const JUSTIFI_BASE_URL = '/payments-platform/justifi-integration';

export const getMerchantData = async ({ locationId }: GetMerchantConnectionRequest) => {
  const { data } = await CustomAxios.get<GetMerchantConnectionResponse>(
    `${JUSTIFI_BASE_URL}/merchant-connections/${locationId}`
  );
  return data;
};

export const getWebComponentToken = async ({
  webComponentUiContext,
  locationId,
  disputeId,
}: CreateWebComponentTokenRequest) => {
  const { data } = await CustomAxios.post<CreateWebComponentTokenResponse>(
    `${JUSTIFI_BASE_URL}/web-component-tokens`,
    { webComponentUiContext, locationId, disputeId }
  );
  return data;
};

export interface ListResponse extends ListDisputesResponse {
  nextPageToken: string;
}

export interface ListRequest extends ListDisputesRequest {
  pageToken?: string;
  pageSize?: number;
}

export const getDisputeList = async ({
  locationId,
  pageToken,
  pageSize = 10,
}: ListRequest) => {
  const { data } = await CustomAxios.post<ListResponse>(`${JUSTIFI_BASE_URL}/disputes`, {
    locationId,
    pageToken,
    pageSize,
  });
  return data;
};

export const getSubAccountSettings = async ({
  locationId,
}: GetSubAccountSettingsRequest) => {
  const { data } = await CustomAxios.get<GetSubAccountSettingsResponse>(
    `${JUSTIFI_BASE_URL}/sub-account-settings/${locationId}`,
    { params: { locationId } }
  );
  return data;
};
